<!--  BEGIN CONTENT PART  -->
<div id="content" class="main-content">
    <div class="container">
        <!-- ADD CUSTOMER MESSAGES ############################################### -->
        <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
            id="customer_added" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
            position: absolute;background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important;"> 
            <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
            <strong>Nouveau client</strong> Ajouté avec succès</div>
        <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
            id="customer_not_added" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
            position: absolute;background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;"> 
            <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
            <strong>Ajout Echoué</strong> {{addError}}</div>
        <!-- DELETE CUSTOMER MESSAGES ############################################### -->
        <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
            id="customer_deleted" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
            position: absolute;background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important;"> 
            <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
            <strong>Suppression</strong> Le client est supprimé</div>
        <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
            id="customer_not_deleted" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
            position: absolute;background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;"> 
            <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
            <strong>Suppression Echouée</strong>, le client n'est pas supprimé suite à un problème</div>
        <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
            id="customer_not_deleted_have_visits" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
            position: absolute;background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;"> 
            <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
            <strong>Suppression Echouée</strong>, Ce client a déjà des visites créées </div>
        <!-- ARCHIVE CUSTOMER MESSAGES ############################################### -->
        <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
            id="customer_archived" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
            position: absolute;background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important;"> 
            <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
            <strong>Archivage</strong> Le client est archivé</div>
        <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
            id="customer_not_archived" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
            position: absolute;background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;"> 
            <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
            <strong>Archivage Echoué</strong>, le client n'est pas archivé suite à un problème</div>
        <!-- UPDATE CUSTOMER MESSAGES ############################################### -->
        <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
            id="customer_updated" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
            position: absolute;background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important;"> 
            <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
            <strong>Client modifié</strong> Les informations du client sont modifiées</div>
        <div class="col-xl-12 col-lg-12 mb-4 col-md-12 col-sm-12 alert alert-gradient alert-danger" 
            id="customer_not_update" role="alert" style="z-index: 100;position: absolute;display: none;right: 7%;
            position: absolute;background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;"> 
            <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
            <strong>Modification Echouée</strong> erreur lors de la modification
        </div>
        <div class="col-12" style="display: flex; justify-content: center;">
            <div id="copyMessage">
                <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="icon-sm" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                    <polyline points="22 4 12 14.01 9 11.01"></polyline>
                </svg>
                Liste des clients copiée avec succès !
            </div>
        </div>
        

        <div class="page-header ">
            <div class="page-title col-lg-12 col-md-12 col-sm-12 col-xs-12 justify-content-between ">
                <h2 class="col-sm-12 col-xs-12">
                    <b>Liste des clients</b>
                    <span *ngIf="loadingAddingCustomer" class="cp-spinner cp-bubble loading_circles" 
                        style="display: block;"></span>
                </h2>
            </div>
        </div>
        <div>
            <div class="row ">
                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0"  [ngClass]="{'d-flex justify-content-between': !mobile && (role=='adm' || role == 'asst')}">
                    <div>
                        <a href="javascript:void(0)" class="badge badge-info mr-2 mb-2 btn-rounded btn-filter" (click)="getCustomersCritary('all',$event)">
                            Tout</a>
                        <a href="javascript:void(0)" class="badge badge-primary mr-2 mb-2 btn-rounded" (click)="getCustomersCritary('affected',$event);hideBlocList();">Clients affectés</a>
                        <a href="javascript:void(0)" class="badge badge-secondary mr-2 mb-2 btn-rounded" (click)="getCustomersCritary('notAffected',$event);">Clients non affectés 
                            <!-- <span *ngIf="countNotAffected!=null && countNotAffected>0">-{{countNotAffected}}-</span> -->
                        </a>
                        <a href="javascript:void(0)" class="badge badge-success mr-2 mb-2 btn-rounded" (click)="getCustomersCritary('classified',$event);hideBlocList();">Clients classés</a>
                        <a href="javascript:void(0)" class="badge badge-default mr-2 mb-2 btn-rounded" (click)="getCustomersCritary('notClassified',$event);">Clients non classés 
                            <span *ngIf="countUnclassified!=null">-{{countUnclassified}}-</span>
                        </a>
                        <a href="javascript:void(0)" class="badge badge-default mr-2 mb-2 btn-rounded btn-gradient-warning" 
                            *ngIf="user?.roles?.includes('CLIENT_CONSULTATION_ARCHIVE')"
                            (click)="getArchivedCustomers('all',$event);">Clients archivés 
                        </a>
                    </div>
                    <div [ngClass]="{'d-flex align-items-center': !mobile && (role=='adm' || role == 'asst')}"> 
                        <a class="badge badge-success mrs-2 mb-2 btn-rounded" href="/goals/current;cm=all" *ngIf="role == 'adm' && mobile">
                            <i class="flaticon-dollar-coin" style="font-size: large;"></i></a>
                        <a href="/goals/current;cm=all" class="badge badge-success mrs-2 mb-2 btn-rounded pr-3 ml-3" *ngIf="role == 'adm' && !mobile">
                            <i class="flaticon-dollar-coin" style="font-size: large;"></i> Objectifs</a>
                        <a href="javascript:void(0)" class="badge badge-secondary mrs-2 mb-2 btn-rounded" href="javascript:void(0)" data-toggle="modal"
                            data-target="#indicatorsModal" *ngIf="role == 'adm' && mobile"><i class="flaticon-stats" style="font-size: large;"></i></a>
                        <a href="javascript:void(0)" (click)="getCustomersIndicators(); getIndicators()" class="badge badge-secondary mrs-2 mb-2 btn-rounded pr-3 ml-3" href="javascript:void(0)" data-toggle="modal" 
                            data-target="#indicatorsModal" *ngIf="role == 'adm' && !mobile"><i class="flaticon-stats" style="font-size: large;"></i> Indicateurs</a>
                            <a type="button" class="btn btn-gradient-dark ml-2 mb-2 btn-rounded btn_new_customer" 
                            href="new-customer" routerLink="/new-customer" >
                            <i class="flaticon-plus-1 mr-2"></i> Nouveau client</a>
                    </div>
                </div>
                <div class="control-group col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="showClasses">
                    <b>Veuillez séléctionner une classe pour voir ses clients :</b><br *ngIf="mobile">
                    <label class="control control--radio m-2" *ngFor="let classe of classes">{{classe?.refClass}}
                        <input type="radio" name="radioClass"  [value]="classe?.uuid" (click)="getCustomersCritary('classifiedAffected','');selectedClass(classe?.uuid)"/>
                        <div class="control__indicator"></div>
                    </label>
                    <label class="control control--radio m-2">Tout
                        <input type="radio" name="radioClass" value="all" (click)="selectedClass('');getCustomersCritary('ofAllClasses','');"/>
                        <div class="control__indicator"></div>
                    </label>
                </div>
                <div class="control-group col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngIf="showCommercials">
                    <b>Veuillez séléctionner un commercial pour voir ses clients :</b><br *ngIf="mobile">
                    <label class="control control--radio m-2" *ngFor="let commercial of commercials">{{commercial?.commercial}}
                        <input type="radio" name="radio"  [value]="commercial?.commercial_uuid" 
                            (click)="customersOfCommercial(commercial?.commercial_uuid,typeFilter)"/>
                        <div class="control__indicator"></div>
                    </label>
                    <label class="control control--radio m-2" *ngIf="typeFilter=='WITHCLSS'">Tout
                        <input type="radio" name="radio" class="all_radio"
                            (click)="getCustomersCritary('classified',$event);"/>
                        <div class="control__indicator"></div>
                    </label>
                    <!-- <label class="control control--radio m-2" *ngIf="typeFilter=='NOCLSS'">Tout
                        <input type="radio" name="radio" class="all_radio"
                            (click)="getCustomersCritary('notClassified',$event);"/>
                        <div class="control__indicator"></div>
                    </label> -->
                </div>
            </div>
            <div class="row" *ngIf="showBloc">
                <!-- <div class="col col-lg-4 col-md-4 col-sm-12 col-xs-12 text-center">
                </div> -->
                <div class="col col-lg-12">

                    <div class="row" id="cancel-row" >
                        <div class="col-xl-12 col-lg-12 pr-0 pl-0 layout-spacing">
                            <div class="statbox widget box box-shadow">
                                <div class="widget-header">
                                    <div class="row">       
                                    </div>
                                </div>
                                <div class="widget-content widget-content-area pl-0 pr-1">
                                    <div *ngIf="customersLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                                    margin-bottom: 15%;"></div>
                                    <div class="table-responsive mb-4" *ngIf="!customersLoading">
                                        <table id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th>Client/Prospect</th>
                                                    <th>Secteur</th>
                                                    <th>Date d'ajout</th>
                                                    <th>Ville</th>
                                                    <th>Affecté à</th>
                                                    <th>Classe</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let customer of allCustomers" id="{{customer?.customer}}">
                                                    <td>
                                                        <!-- <a href="javascript:void(0);" data-toggle="modal" data-target="#ficheModal" (click)="selectCustomer(customer?.customer);"
                                                            class="mr-2 action_plan_unique customer" title="Voir détail client">
                                                            {{customer?.customer_rs}}
                                                        </a> -->
                                                        <a [attr.href]="'/customer/fromshow;cs='+customer?.customer+';vs='" class="mr-2 action_plan_unique customer" title="Voir détail client">
                                                            {{customer?.customer_rs}}
                                                        </a>
                                                    </td>
                                                    <td style="font-size: smaller;">
                                                        {{customer?.customer_sector || '----'}}
                                                    </td>
                                                    <td>
                                                        <span *ngIf="customer?.customer_added_at!=undefined && customer?.customer_added_at!=null">
                                                            {{customer?.customer_added_at | date: 'dd-MM-yyyy'}}</span>
                                                        <span *ngIf="customer?.customer_added_at==undefined || customer?.customer_added_at==null">
                                                            - - -</span>
                                                    </td>
                                                    <td>
                                                        <span *ngIf="customer?.customer_cities && customer.customer_cities.length === 1">
                                                            {{ customer.customer_cities[0].name }}
                                                        </span>
                                                        
                                                        <span *ngIf="customer?.customer_cities && customer.customer_cities.length > 1" class="con-tooltip right">
                                                            Plusieurs
                                                            <div class="tooltip city-list" [innerHTML]="getCityNames(customer.customer_cities)"></div>
                                                        </span>
                                                        
                                                      </td>
                                                    <td>
                                                        <!-- <span *ngIf="customer?.added_by!=undefined && customer?.added_by!=null && !customer?.added_by_me">
                                                            {{customer?.added_by}}</span>
                                                        <span *ngIf="!customer?.added_by_me && (customer?.added_by==undefined || customer?.added_by==null)">
                                                            - - -</span>
                                                        <span *ngIf="customer?.added_by_me">
                                                            <b>Moi</b></span> -->
                                                            
                                                            <span *ngIf="customer?.commercials.length>0">
                                                                {{customer?.commercials[customer?.commercials.length-1].commercial}}</span>
                                                            <span *ngIf="customer?.commercials.length==0">
                                                                - - -</span>
                                                    </td>
                                                    <td>
                                                        <span class="c-p-price-inc" *ngIf="customer?.customerClass!=undefined && customer?.customerClass!=null"
                                                            style="font-size: smaller;">
                                                            <b>{{customer?.customerClass?.refClass}}</b></span>
                                                        <span class="c-p-price-inc" *ngIf="customer?.customerClass==undefined || customer?.customerClass==null"
                                                            style="font-size: smaller;">
                                                            <b>- - -</b></span>
                                                        <div class="progress mt-1" *ngIf="customer?.customerClass?.refClass=='Classe A'">
                                                            <div class="progress-bar bg-success" role="progressbar" style="width: 100%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                        </div>
                                                        <div class="progress mt-1" *ngIf="customer?.customerClass?.refClass=='Classe B'">
                                                            <div class="progress-bar bg-secondary" role="progressbar" style="width: 100%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                        </div>
                                                        <div class="progress mt-1" *ngIf="customer?.customerClass?.refClass=='Classe C'">
                                                            <div class="progress-bar bg-warning" role="progressbar" style="width: 100%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                        </div>
                                                        <div class="progress mt-1" *ngIf="customer?.customerClass?.refClass=='Classe D'">
                                                            <div class="progress-bar bg-dark" role="progressbar" style="width: 100%" aria-valuenow="75" aria-valuemin="0" aria-valuemax="100"></div>
                                                        </div>
                                                    </td>
                                                    <td class="text-center">
                                                        <!-- <div class="dropdown custom-dropdown" *ngIf="allCustomers.length>=5">
                                                            <a class="dropdown-toggle" href="#" role="button" id="dropdownMenuLink1" data-toggle="dropdown" aria-haspopup="true" 
                                                                aria-expanded="true" >
                                                                <i class="flaticon-dot-three"></i>
                                                            </a>
                                                            <div class="dropdown-menu" aria-labelledby="dropdownMenuLink1">
                                                                <a class="dropdown-item" data-toggle="modal" data-target="#ficheModal" (click)="selectCustomer(customer?.customer);">
                                                                    Consulter</a>
                                                                <a class="dropdown-item"  href="javascript:void(0);" data-toggle="modal" 
                                                                    data-target="#updateCustomer" (click)="selectCustomerToUpdate(customer?.customer)">
                                                                    Modifier</a>
                                                                <a class="dropdown-item"  href="javascript:void(0);" data-toggle="modal" *ngIf="customer?.added_by_me"
                                                                    data-target="#deleteCustomer" (click)="selectToDelete(customer?.customer);selectCustomer(customer?.customer);">
                                                                    Supprimer</a>
                                                            </div>
                                                        </div> -->
                                                        <span class="d-flex">
                                                            <!-- <a href="javascript:void(0);" data-toggle="modal" *ngIf="customer?.added_by_me || role=='adm'" class="mr-2 action_plan_unique"
                                                                data-target="#updateCustomer" (click)="selectCustomerToUpdate(customer?.customer)" title="Modifier le client">
                                                                <i class="flaticon-pencil-1"></i></a> -->
                                                            <a [attr.href]="'edit-customer/'+customer?.customer " *ngIf="customer?.added_by_me || role=='adm'|| role=='asst'" class="mr-2 action_plan_unique"
                                                                 title="Modifier le client">
                                                                <i class="flaticon-pencil-1"></i>
                                                            </a>
                                                            <a href="javascript:void(0);" data-toggle="modal" *ngIf="user?.roles?.includes('CLIENT_ARCHIVAGE')
                                                                && (!customer?.archived || customer?.archived==undefined)" class="mr-2 action_plan_unique"
                                                                title="Archiver le client"  data-target="#archiveCustomer" 
                                                                (click)="selectToDelete(customer?.customer);selectCustomer(customer?.customer)">
                                                                <i class="flaticon-folder"></i></a>
                                                            <a href="javascript:void(0);" data-toggle="modal" *ngIf="user?.roles?.includes('CLIENT_SUPPRESSION') 
                                                                && (customer?.added_by_me || role=='adm') && customer?.archived" class="mr-2 action_plan_unique"
                                                                title="Supprimer le client"  data-target="#deleteCustomer" 
                                                                (click)="selectToDelete(customer?.customer);selectCustomer(customer?.customer);getCustomerVisits(customer?.customer)">
                                                                <i class="flaticon-delete"></i></a>
                                                            <a href="javascript:void(0);" data-toggle="modal" data-target="#visitsModal" (click)="selectCustomer(customer?.customer); getCustomerVisits(customer?.customer)"
                                                                class="mr-2 action_plan_unique" title="Voir l'historique des visites du client">
                                                                <i class="flaticon-left-menu"></i></a>
                                                        </span>
                                                    </td>
                                                </tr>
                                        </table>
                                    </div>
                                </div>
                            </div>    
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</div>

<!--  Delete Client Modal -->
<div id="deleteCustomer" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
    <div class="modal-dialog modal-lg"> 
        <div class="modal-content">
            <div class="modal-header border-0">
                <div class="col-lg-12 text-center data-widgets br-4">
                    <div class="widget  t-sales-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-minus-1" style="background-color: #e7515a;color: white;"></i>
                            </div>
                        </div>
                    </div>
                </div>   
            </div>
            <div  class="form-group text-center row mb-4 col-lg-12 col-lg-12 col-md-12 col-sm-12 ml-1" style="width: 100%;">
                <b class="col-lg-12 col-lg-12 col-md-12 col-sm-12">Êtes-vous sûr de vouloir supprimer le client : <b>{{selectedCustomer?.customer_rs}}</b> ?</b>
            </div>
            <div class="col-xl-12 col-lg-12 col-sm-12">
                <div class="row justify-content-center align-items-end" *ngIf="custVisits.length>0 && !loadingCustomersVisits">
                    <div>
                        <h4 class="modal-title mb-4 rs_customer text-center" id="exampleSuccessAlertLabel">
                            <b>Ce client <span *ngIf="!loadingCustomersVisits && custVisits.length>0">est visité {{custVisits.length}} fois</span></b>
                        </h4>
                    </div>
                </div>
                <div *ngIf="loadingCustomersVisits" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;
                    margin-bottom: 1%;">
                </div>
                <div *ngIf="!loadingCustomersVisits && custVisits.length==0" class="text-center">
                    <p>Pas de visites pour ce client</p>
                </div>
                <div *ngIf="!loadingCustomersVisits && custVisits.length>0" class= "custVisits text-justify">
                    <div class="row mx-auto " *ngFor="let el of custVisits; let i=index;">
                        <div class="col-5 col-md-4 col-lg-2 row" [ngClass]="{'pr-0': mobile }">
                            <div>
                                <div class="visit_rounder"></div>
                                <div *ngIf="i<(custVisits.length-1)" class="visit_line"></div>
                            </div>
                            <div>
                                <div class="visit_line_horizon" [ngClass]="{'mr-3': !mobile }"></div>
                            </div>
                        </div>
                        <div class="col" [ngClass]="{'pl-0': mobile }">
                            <h4 class="font-weight-bold">{{el.visitPlannedDate | date: "dd/MM/yyyy"}} : 
                                <br *ngIf="mobile"><a href="visite/detail/customers;cr={{el.visitUuid}}" class="visit_link">Visite {{el.visitStatus | titlecase}}</a></h4>
                            <h5 class="mb-0" *ngIf="el.actions.length>0"><b>Actions : </b></h5>
                            <ul *ngIf="el.actions.length>0" class="ml-1" [ngClass]="{'pl-0': mobile }">
                                <li *ngFor="let item of el.actions">
                                    - {{item.action_label|titlecase}}: {{item.action_type}} - {{item.action_status}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="alert_reminder">
                    <p><b>Attention !</b> En confirmant cette suppression, vous allez également supprimer automatiquement 
                        tous les éléments associés: actions, visites, messages et contacts. Cette opération est <b>irréversible</b>. 
                        Êtes-vous sûr de vouloir continuer?</p>
                </div>
                <div class="">  
                    <div class="text-center md-button" style="display: grid;">
                        <button type="button" class="btn btn-danger btn-rounded mt-3 mb-0 mr-2"
                            data-dismiss="modal" (click)="deleteCustomer()">Supprimer le client 
                            <span *ngIf="custVisits.length>0">et ses visites</span></button>
                        <button type="button" class="btn btn-default btn-rounded mt-2 mb-3" data-dismiss="modal">Annuler</button>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</div>

<!--  Archive Client Modal -->
<div id="archiveCustomer" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
    <div class="modal-dialog modal-md"> 
        <div class="modal-content">
            <div class="modal-header border-0">
                <div class="col-lg-12 text-center data-widgets br-4">
                    <div class="widget  t-sales-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-folder btn-gradient-warning" style="background-color: #ffa42c;color: white;"></i>
                            </div>
                        </div>
                    </div>
                </div>   
            </div>
            <div id="date" class="form-group text-center row mb-4 col-lg-12 col-lg-12 col-md-12 col-sm-12 ml-1" style="width: 100%;">
                <b class="col-lg-12 col-lg-12 col-md-12 col-sm-12">Êtes-vous sûr de vouloir archiver le client : 
                    <br><b>{{selectedCustomer?.customer_rs}}</b> ?</b>
            </div>
            <div class="col-xl-12 col-lg-12 col-sm-12">
                <div class="">  
                    <div class="text-center md-button" style="display: grid;">
                        <button type="button" class="btn btn-gradient-warning btn-rounded mt-3 mb-0 mr-2"
                            data-dismiss="modal" (click)="archiveCustomer()">Archiver le client 
                            <span *ngIf="custVisits.length>0">et ses visites</span></button>
                        <button type="button" class="btn btn-default btn-rounded mt-2 mb-3" data-dismiss="modal">Annuler</button>
                    </div> 
                </div>
            </div>
        </div>
    </div>
</div>

<!--  Fiche Client Modal -->
<div id="ficheModal" class="modal animated rotateInDownLeft custo-rotateInDownLeft show text-center"  tabindex="-1" role="dialog" aria-labelledby="exampleSuccessAlertLabel">
    <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
        <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            <div class="">
                <i class="flaticon-building-1 mt-5"></i>
                <h4 class="modal-title mt-4 mb-4 rs_customer" id="exampleSuccessAlertLabel">
                    <b>{{selectedCustomer?.customer_rs}}</b>
                </h4>
            </div>
            <div class="row align-items-end">
                <div class="col-lg">
                    <form id="contact_form">
                        <div class=" col-lg-12 col-md-12">
                            <div class="row mt-2 col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;text-align: left;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 right_inputs">
                                    <label class="col-lg-6 col-md-6 col-sm-12 col-xs-12 
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);"> 
                                        <b>Secteur :</b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0"> 
                                        <p style="margin-top: 2%;margin-left: 5%;">{{selectedCustomer?.customer_sector}}</p> 
                                    </div>
                                </div>
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 right_inputs">
                                    <label class="col-lg-6 col-md-6 col-sm-12 col-xs-12 
                                        col-form-label col-form-label-sm pl-0" style="color: rgb(22, 22, 22);">
                                        <b>Représentant:</b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0"> 
                                            <p style="margin-top: 2%;"> <span *ngIf="selectedCustomer?.customer_agent == null || selectedCustomer?.customer_agent == ''">---</span>{{selectedCustomer?.customer_agent}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Adresse & Ville :</b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;">
                                            <span *ngIf="selectedCustomer?.customer_cities == null || selectedCustomer?.customer_cities.length == 0">---</span>
                                            <span *ngIf="selectedCustomer?.customer_address != null && selectedCustomer?.customer_address != ''"> {{selectedCustomer?.customer_address}},</span> 
                                            <span *ngIf="selectedCustomer?.customer_cities != null">
                                                <ng-container *ngFor="let city of selectedCustomer?.customer_cities; let last = last">
                                                    {{ city.name }}{{ last ? '' : ', ' }}
                                                </ng-container>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>N° Téléphone : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;"><span *ngIf="selectedCustomer?.customer_phone == null || selectedCustomer?.customer_phone == ''">---</span>{{selectedCustomer?.customer_phone}}</p> 
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="config.skypeVisibility" class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>N° Skype : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;">{{selectedCustomer?.customer_skype || '---'}}</p> 
                                    </div>
                                </div>
                            </div>
                            <div *ngIf="config.zipCodeVisibility" class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Code Zip : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;">{{selectedCustomer?.customer_zip_code || '---'}}</p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Classe : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;">
                                            <span *ngIf="selectedCustomer?.customerClass == null">---</span>
                                            <b *ngIf="selectedCustomer?.customerClass != null " [ngClass]="{'text-success': selectedCustomer?.customerClass?.refClass == 'Classe A', 
                                            'text-secondary': selectedCustomer?.customerClass?.refClass == 'Classe B',
                                            'text-warning': selectedCustomer?.customerClass?.refClass == 'Classe C',
                                            'text-dark': selectedCustomer?.customerClass?.refClass == 'Classe D' }">
                                                {{selectedCustomer?.customerClass?.refClass}}
                                            </b>
                                        </p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Ajouté le : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;">
                                            <span *ngIf="selectedCustomer?.customer_added_at == null">---</span>
                                            {{selectedCustomer?.customer_added_at | date: 'dd-MM-yyyy'}}
                                        </p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Commercial : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;">
                                            <span *ngIf="!selectedCustomer?.commercials[0]?.commercial">---</span>
                                            {{selectedCustomer?.commercials[0]?.commercial | titlecase}}
                                        </p> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg">
                    <!-- MESSAGES -->
                    <div>
                        <h4 class="text-primary mb-1" style="margin-left: 2%;color: rgb(22, 22, 22)">Conversation</h4>
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="mail-chat-system">
                                <div class="chat_window">
                                    <div *ngIf="loadingMessages" class="cp-spinner cp-skeleton spinner_messages"></div> 
                                    <p *ngIf="messages!.length==0 && !loadingMessages" class="text-center" style="color:gray;">Aucun message pour ce Client</p>
                                    <ul class="chat-messages pl-0 pt-5" *ngIf="messages.length>0">
                                        <!-- <span *ngFor="let message of messages"> -->
                                        <div class="message appeared" style="top: 10%;" *ngFor="let message of messages; let i=index; let last = last"
                                            [ngStyle]="{'margin-top': i>0 ? '70px' : '0px'}"
                                            [ngClass]="{'right': message.sender == 'me', 'left': message.sender != 'me' }">
                                            <div class="avatar" 
                                                [ngStyle]="{'background-image': message.sender_avatar == null ? 'url(../assets/img/me.jpg)' : 'url(data:image/jpg;base64,'+message.sender_avatar+ ')' }"
                                                > </div>
                                            <div class="text_wrapper">
                                                <div class="text mt-7 mb-7" [ngClass]="{'urgent_msg': message.important,' ': !message.important}" >
                                                    <p class="text-left">{{message.message}}</p>
                                                    <p class="text-left mb-0 mt-4" style="text-align: initial !important;font-size: smaller;"
                                                    [ngClass]="{'text-dark': message.sender == 'me', 'text-default': message.sender != 'me' }">
                                                        <b>{{message?.sent_at | date: 'dd/MM/yyyy - HH:mm '}}</b>
                                                    </p>
                                                    <span *ngIf="message.important && last" class="text-right" style="font-size: smaller;">
                                                        <img src="assets/img/suivitim_img/important.gif" *ngIf="message.sender == 'me'" style="width: 20px;height: 20px;border: unset;">
                                                        <img src="assets/img/suivitim_img/important_other.gif" *ngIf="message.sender != 'me'" style="width: 20px;height: 20px;border: unset;">
                                                            <b> En attente de réponse !</b></span>
                                                </div>
                                            </div>
                                            <span class="mb-2 ml-2 badge badge-pills outline-badge-primary seeAt mt-1" 
                                                *ngIf="message.sender == 'me' && message.seen">
                                                {{message?.see_at | date: 'dd/MM/yyyy - HH:mm '}} <img src="assets/img/suivitim_img/commentSeen.gif"
                                                style="width: 20px;height: 20px;border: unset;"></span>
                                        </div>
                                    </ul>
                                    <div class="chat-bottom-section mt-3 clearfix">
                                        <div class="input-group mb-2 message_input_wrapper">
                                            <div class="input-group-prepend" id="msg_urgent">
                                                
                                            </div>
                                            <input type="text" class="message_input form-control" id="messageText" style="border-radius: 10px;"
                                                placeholder="Saisir votre message ...">
                                            <div class="input-group-append ml-0">
                                                <button class="input-group-text br-0" (click)="sendNewMessage(selectedCustomer?.customer)">Envoyer 
                                                    <i *ngIf="!sending" class="flaticon-send-fill-1"></i>
                                                    <img *ngIf="sending" src="../../../assets/img/envoyer-message-enveloppe.gif" alt="" width="25px">
                                                </button>
                                            </div>
                                            
                                            
                                        </div>
                                        <div class="custom-control rounded-chk custom-checkbox checkbox-primary">
                                            <input type="checkbox" class="custom-control-input" id="roundedChk2" checked="">
                                            <label class="custom-control-label" for="roundedChk2">J'attends la réponse</label>
                                        </div>
                                            
                                    </div>
                                </div>
                                <div class="message_template d-none">
                                    <div class="message">
                                        <div class="avatar"></div>
                                        <div class="text_wrapper">
                                            <div class="text"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

                    
            <button type="button" class="btn btn-gradient-default btn-rounded mt-3 mb-4" data-dismiss="modal">Retour</button>
        </div>
        </div>
    </div>
</div>

<!-- Client Visits Modal -->
<div id="visitsModal" class="modal animated rotateInDownLeft custo-rotateInDownLeft show text-center" tabindex="-1"
    role="dialog" aria-labelledby="exampleSuccessAlertLabel">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-body">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">×</span>
                </button>
                <div class="row justify-content-center  align-items-end">
                    <div>
                        <i *ngIf="selectedCustomer?.customer_logo == null" class="flaticon-building-1 mt-5"></i>
                        <span class="p-7 d-flex justify-content-center mb-10" id="imageDiv"></span>
                        <h3 class="mt-2">Historique des visites</h3>
                        <h4 class="modal-title mb-4 rs_customer" id="exampleSuccessAlertLabel">
                            <b>{{selectedCustomer?.customer_rs}} <span *ngIf="!loadingCustomersVisits && custVisits.length>0">visité {{custVisits.length}} fois</span></b>
                        </h4>
                    </div>
                </div>

                <div *ngIf="loadingCustomersVisits" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;
                    margin-bottom: 1%;">
                </div>
                <div *ngIf="!loadingCustomersVisits && custVisits.length==0">
                    <p>Pas de visites pour ce client</p>
                </div>
                <div *ngIf="!loadingCustomersVisits && custVisits.length>0" class= "custVisits text-justify">
                    <div class="row mx-auto " *ngFor="let el of custVisits; let i=index;">
                        <div class="col-5 col-md-4 col-lg-2 row">
                            <div>
                                <div class="visit_rounder"></div>
                                <div *ngIf="i<(custVisits.length-1)" class="visit_line"></div>
                            </div>
                            <div>
                                <div class="visit_line_horizon mr-3"></div>
                            </div>
                        </div>
                        <div class="col">
                            <h4 class="font-weight-bold">{{el.visitPlannedDate | date: "dd/MM/yyyy"}} : Visite {{el.visitStatus | titlecase}}</h4>
                            <h5 class="mb-0" *ngIf="el.actions.length>0">Actions:</h5>
                            <ul *ngIf="el.actions.length>0" class="ml-1">
                                <li *ngFor="let item of el.actions">
                                    - {{item.action_label|titlecase}}: {{item.action_type}} - {{item.action_status}}
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <button type="button" class="btn btn-gradient-default btn-rounded mt-3 mb-4"
                    data-dismiss="modal">Retour</button>
            </div>
        </div>
    </div>
</div>

<!-- Client Visits Modal -->
<div id="indicatorsModal" class="modal animated show text-center" tabindex="-1" *ngIf="role == 'adm'"
    role="dialog" aria-labelledby="exampleSuccessAlertLabel">
    <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
            <div class="modal-header text-center">
                <h2>Nos indicateurs - Clients</h2>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">x</span>
                </button>
            </div>
            <div class="modal-body">
                    <div class="st-wrapper">
                      <div class="st-background"></div>
                      <div class="st-background"></div>
                      
                      <div class="st-card-container">
                        <div class="st-card small">
                          <div class="st-count-circle">
                            <div *ngIf="loadingCustomersIndicators" class="cp-spinner cp-bubble morph_blue" style="margin: auto;display: block;margin-top: 1%;
                                    margin-bottom: 1%;">
                            </div>
                            <div *ngIf="!loadingCustomersIndicators">
                                <span class="score">{{totalCustomers}}</span>
                                Total des clients
                            </div>
                          </div>
                        </div>
                        <div class="st-card large">
                          <div class="player-info player-info-green">
                            <div class="text" style="width: 195px !important;">
                              <h3 style="color: white;" class="lname">Plus visités</h3>
                              <div *ngIf="loading_indicator" class="cp-spinner cp-bubble morph_green" style="margin: auto;display: block;margin-top: 1%;
                                    margin-bottom: 1%;"></div>
                              <div *ngIf="!loading_indicator">
                                <div class="country" *ngFor="let top of indicators.maxVisits">
                                    <img src="../../assets/img/logo.jpg" alt="PAK" /> {{top?.customer_top_visits}} 
                                    <span *ngIf="top.is_archived" 
                                        style="color: #ffa42c;font-size: 11px;font-weight: 600;">(Archivé)</span>
                                    <div class="score" style="font-size: larger !important;"> 
                                        {{top?.top_visits}} Visites 
                                    </div>
                                    <hr class="m-1">
                                </div>
                                <p *ngIf="indicators.maxVisits.length==0" style="font-size: small;
                                    text-align: left;">Aucune donnée à afficher</p>
                                <span style="font-size: small;text-align: left;">
                                    <p *ngIf="no_indicators || indicators.maxVisits.length==0" class="text-center"> Aucun indicateur</p>
                                </span>
                              </div>
                            </div>
                            <div class="avatar" style="width: 30% !important;">
                                <i class="flaticon-profits-1"></i>
                            </div>
                          </div>
                        </div>
                        <div class="st-card large">
                            <div class="player-info player-info-red">
                                <div class="text" style="width: 195px !important;">
                                    <h3 style="color: white;" class="lname">Moins visités</h3>
                                    <div *ngIf="loading_indicator" class="cp-spinner cp-bubble morph_red" style="margin: auto;display: block;margin-top: 1%;
                                        margin-bottom: 1%;"></div>
                                    <div *ngIf="!loading_indicator">
                                      <div class="country" *ngFor="let less of indicators.minVisits">
                                          <img src="../../assets/img/logo.jpg" alt="PAK" /> {{less?.customer_low_visits}}
                                          <span *ngIf="less.is_archived" 
                                            style="color: #ffa42c;font-size: 11px;font-weight: 600;">(Archivé)</span>
                                          <div class="score" style="font-size: larger !important;"> 
                                            {{less?.low_visits}} Visites
                                            <span *ngIf="less.is_archived" style="color: #ffa42c;">(Archivé)</span>
                                          </div>
                                      </div>
                                        <p *ngIf="indicators.minVisits.length==0" style="font-size: small;
                                            text-align: left;">Aucune donnée à afficher</p>
                                        <span style="font-size: small;text-align: left;">
                                            <p *ngIf="no_indicators || indicators.minVisits.length==0" class="text-center"> Aucun indicateur</p>
                                        </span>
                                    </div>
                                  </div>
                              <div class="avatar" style="width: 30% !important;">
                                <i class="flaticon-loss-arrow"></i>
                              </div>
                            </div>
                          </div>
                        <div class="st-card large">
                          <div class="player-info player-info-blue">
                            <div class="text">
                                <div *ngIf="loadingCustomersIndicators" class="cp-spinner cp-bubble morph_blue" style="margin: auto;display: block;margin-top: 1%;
                                    margin-bottom: 1%;"></div>
                              <div *ngIf="!loadingCustomersIndicators">
                                <a href="javascript:void(0)" target="_blank">
                                  <span class="lname">Référentiel</span>
                                </a>
                                <div class="score"> 
                                    {{custIndicators?.companyCustomers}} <span style="font-size: small;">Clients</span>
                                </div>
                                <span style="color:#5acad5">
                                    <span class="lname mb-3">Clients par commercial</span>
                                </span>
                                <div class="country" *ngFor="let item of rankCustomersByCommercial">
                                  <img [title]="item.commercial" [src]="item.commercialAvatar?'data:image/jpg;base64,'+ item.commercialAvatar :'assets/img/unknown_user.jpg' " 
                                    alt="profile" /> {{item?.customers}} Clients
                                </div>
                              </div>
                            </div>
                            <div class="avatar" style="width: 30% !important;">
                                <i class="flaticon-building-1"></i>
                            </div>
                          </div>
                        </div>
                      </div>                  
                <button type="button" class="btn btn-gradient-default btn-rounded mt-3 mb-4"
                    data-dismiss="modal">Retour</button>
            </div>
        </div>
    </div>
</div>




